import {
  TKwikUIInputPhoneSize,
  VKwikUIInputPhoneSize
} from "./input-phone.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isString = (x: string) => typeof x === "string";

  const methods = {
    countryCode: isString,
    disabled: isBoolean,
    focus: isBoolean,
    formControlName: isString,
    hintContent: isString,
    icon: isString,
    iconLeft: isString,
    id: isString,
    invalid: isBoolean,
    label: isString,
    phoneMaskAfterCountryCode: isString,
    placeholder: isString,
    postfix: isString,
    prefix: isString,
    removeCountryCodeFromValue: isBoolean,
    size: (x: TKwikUIInputPhoneSize) => VKwikUIInputPhoneSize.includes(x)
  };

  return methods[key] && methods[key](value);
};
